import { render } from "./ContratoTransportador.vue?vue&type=template&id=5270f834"
import script from "./ContratoTransportador.vue?vue&type=script&lang=ts"
export * from "./ContratoTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script